<template>
  <div class="contain">
    <div class="top">
      <div class="topleft">
        <img class="topimg" src="../assets/logoshare.png" alt="logo" />
        <div>
          <div style="font-size: 13px; color: #333; font-weight: 700">
            高净值研究院
          </div>
          <div style="color: #999; font-size: 12px">
            学点东西 交点朋友 合作共赢
          </div>
        </div>
      </div>
      <img src="../assets/openwatch.png" class="submit" alt="" @click="saveApp" />
    </div>
    <img v-if="list.cover" :src="baseImg + list.cover" alt="" class="logoPic" />
    <div class="introduction">
      <div class="titles">{{ list.name }}</div>
      <div class="xian"></div>
      <div class="time1">
        <img src="../assets/kctime1.png" alt="" class="detailedInformation" />开始时间：{{ list.startTime }}
      </div>
      <div class="time1 time2">
        <img src="../assets/kctime2.png" alt="" class="detailedInformation" />结束时间：{{ list.endTime }}
      </div>
      <div class="time1">
        <img src="../assets/kcdz.png" alt="" class="detailedInformation" />上课地址：{{ list.address }}
      </div>
    </div>
    <div class="home">
      <div class="particulars">课程详情</div>
      <div v-for="(item, index) in rich" :key="index">
        <div v-if="item.type == 'text'" v-html="item.value"></div>
        <img :src="baseImg + item.file" v-if="item.type == 'image'" alt="" style="width: 100%" />
      </div>
    </div>
    <button class="btnS" oncontextmenu="return false" @click="saveApp">
      确认报名
    </button>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="openTop">
            <van-icon name="cross" style="opacity: 0" /><span class="open">选择打开方式</span><van-icon name="cross"
              @click="close" />
          </div>
          <div class="openWay">
            <wx-open-launch-weapp v-if="isInWeChat" id="launch-btn" :appid="appid" :username="username"
              :path="`/pages/activities/activitInfo/kcactivitInfo?personId=${personId}&id=${id}`">
              <script type="text/wxtag-template">
                <style>.openApplet { width: 55px;height: 55px; }</style><img class="openApplet" src="https://gjzb.xyvcard.com/static/wxminiapp/jumpPic.png" alt="">
                                                        </script>
            </wx-open-launch-weapp>

            <!-- <wx-open-launch-app v-if="isInWeChat && isAndroid" id="launch-btn" appid="wx2aa6f93b06c0be5a"
							extinfo="your-extinfo" @error="handleErrorFn" @launch="handleLaunchFn">
							<script type="text/wxtag-template">
								<style>.openApplet { width: 55px;height: 55px; }</style><img class="openApplet" src="https://gjzb.xyvcard.com/static/wxminiapp/jumpPic.png" alt="">
							</script>
						</wx-open-launch-app> -->

            <!--  v-if="(isInWeChat && !isAndroid) || !isInWeChat" -->
            <div style="width: 55px; height: 55px; position: relative">
              <img style="width: 55px; height: 55px" src="../assets/openapp.png" @click="unfoldApp" alt="" />
              <img src="../assets/tj.png" alt="" style="
                  position: absolute;
                  width: 40px;
                  height: 16px;
                  top: -10px;
                  right: -30px;
                " />
            </div>
          </div>
          <div class="textWay">
            <span v-if="isInWeChat" class="openText">小程序直接打开</span>
            <span class="openText">APP打开</span>
          </div>
        </div>
      </div>
    </van-overlay>

    <div class="bgc" v-show="isFlag">
      <img src="../assets/newAn.png" alt="" />
    </div>
  </div>
</template>

<script>
import { getToken, getUser } from "../api/user";
import { getCourseInfo } from "../api/study";
import { LAUNCH_WEAPP_APPID, LAUNCH_WEAPP_USERNAME } from "../config/config";

export default {
  data() {
    return {
      appid: LAUNCH_WEAPP_APPID,
      username: LAUNCH_WEAPP_USERNAME,
      baseImg: process.env.VUE_APP_BASE_IMG,
      show: false,
      list: [],
      rich: [],
      id: null,
      personId: null,
      isInWeChat: /MicroMessenger/i.test(navigator.userAgent),
      isAndroid:
        navigator.userAgent.indexOf("Android") > -1 ||
        navigator.userAgent.indexOf("Linux") > -1,
      isFlag: false,
      timer: null,
    };
  },
  mounted() {
    // console.log(123, "=> 132");
    // console.log(this.$route.query.code, "=> code");
    // if (this.$route.query.code) {
    //   console.log("已授权");
    // } else {
    //   this.isInWeChat && this.wxshowMsg();
    // }
  },
  created() {
    this.$initWeChatSDK();
    if (this.$route.query.code) {
      this.getToken(this.$route.query.code);
    }
    const id = this.$route.query.id;
    this.id = id;
    this.personId = this.$route.query.personId;
    this.getClass({
      id,
    });
  },

  methods: {
    // 微信分享
    handleShareData() {
      const data = {
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        title: this.list.name, // 分享标题
        imgUrl: this.baseImg + this.list.cover, // 分享图标
        desc: '' // 分享描述
      }
      console.log(data, '=> data');

      this.$wx.ready(() => {   //需在用户可能点击分享按钮前就先调用
        this.$wx.updateAppMessageShareData({
          ...data,
        })

        this.$wx.updateTimelineShareData({
          ...data
        })
      });
    },

    wxshowMsg() {
      const callback = encodeURIComponent(window.location.href); // 获取当前地址，跳转至以下腾讯地址会携带code重定向到该地址
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${callback}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    },
    async getClass(params) {
      const data = await getCourseInfo(params);
      this.list = data.data.data;
      this.rich = JSON.parse(data.data.data.introduction);
      this.rich.forEach((item) => {
        if (item.type == "text") {
          item.value = item.value.replace(
            /\<img/gi,
            '<img style="width:100%";height:auto'
          );
        }
      });

      this.handleShareData()
    },
    async getToken(code) {
      const { data } = await getToken({
        code,
      });
      console.log(data.data.token, "token");
      localStorage.setItem("gjz_Token", data.data.token);
      await this.getUser();
    },
    async getUser() {
      const data = await getUser();
      console.log(data);
    },
    saveApp() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    unfoldApp() {
      const u = navigator.userAgent; // 判断是安卓还是iOS
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // 判断是否是 android终端
      if (isAndroid) {
        if (this.isInWeChat) {
          this.isFlag = true;
          this.show = false;
        } else {
          window.location.href = `gjzb://${process.env.VUE_APP_AND_URL}/h5/Class?id=${this.id}&personId=${this.personId}`;
          this.timer = setTimeout(() => {
            window.location = `${process.env.VUE_APP_IOS_URL}/h5/Download`;
          }, 3000);

          document.addEventListener("visibilitychange", async () => {
            if (document.visibilityState == "hidden") {
              //页面隐藏
              if (this.timer) clearTimeout(this.timer);
            }
          });
        }
      } else {
        window.location.href = `${process.env.VUE_APP_IOS_URL}/h5/Download?id=${this.id}&personId=${this.personId}&type=course`;
      }
    },

    handleErrorFn(e) {
      this.isFlag = true;
      this.show = false;
      // console.log(e, "=> e");
      // this.$router.push("/Download");
      // alert(e.detail.errMsg)
    },
    handleLaunchFn(e) {
      console.log(e, "=> e");
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.bgc {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: gray;
  z-index: 999;

  //opacity: .9;
  img {
    touch-action: manipulation;
    display: block;
    /* 去除图片下方的默认空白间距 */
    /* 防止浏览器默认的双指缩放操作 */
    width: 100%;
    height: 100%;
  }
}

.contain {
  box-sizing: border-box;
  //padding: 0 30px;
  background: #fff;
  width: 100%;
  height: 100%;
}

.top {
  height: 120px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 998;
  width: 100vw;
}

.topleft {
  display: flex;
  align-items: center;
}

.submit {
  margin-right: 30px;
  width: 130px;
}

.topimg {
  width: 90px;
  height: 90px;
  margin-left: 40px;
  margin-right: 20px;
  margin-top: 20px;
}

.logoPic {
  position: absolute;
  top: 120px;
  z-index: 0;
  width: 750px;
  object-fit: cover;
  height: 353px;
}

.introduction {
  position: absolute;
  width: 750px;
  height: 360px;
  background: #fff;
  border-radius: 50px 50px 0px 0px;
  top: 423px;
  padding: 50px 30px;
}

.detailedInformation {
  width: 14px;
  height: 14px;
  margin-right: 9px;
}

.titles {
  width: 684px;
  height: 84px;
  font-size: 30px;
  font-weight: 600;
  color: #333333;
  line-height: 42px;
}

.xian {
  width: 690px;
  height: 1px;
  margin: 30px auto 25px;
  background: #d8d8d8;
}

.time1 {
  height: 33px;
  font-size: 26px;
  font-weight: 400;
  color: #333333;
  line-height: 33px;
  vertical-align: top;
  width: 550px;
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的文本 */
  text-overflow: ellipsis;
  /* 显示省略号 */
}

.time2 {
  margin: 20px 0;
}

.address {
  width: 96px;
  height: 33px;
  font-size: 24px;
  font-weight: 400;
  color: #1d4687;
  line-height: 33px;
  float: right;
}

.home {
  position: absolute;
  height: 120px;
  top: 783px;
  text-align: center;
  width: 100%;
  background: #f6f6f6;
}

.particulars {
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  color: #333333;
  line-height: 120px;
}

.btnS {
  width: 690px;
  height: 90px;
  background: #1d4687;
  box-shadow: 0px 0px 20px 0px rgba(107, 107, 107, 0.5);
  border-radius: 50px;
  font-size: 30px;
  font-weight: 600;
  color: #ffffff;
  line-height: 90px;
  position: fixed;
  bottom: 42px;
  left: 27px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 690px;
  height: 370px;
  background: #ffffff;
  border-radius: 10px;
}

.openTop {
  padding: 30px 22px;
  display: flex;
  justify-content: space-between;
}

.open {
  width: 400px;
  text-align: center;
  height: 42px;
  font-size: 30px;
  font-weight: 500;
  color: #333333;
}

.openWay {
  padding-top: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.openText {
  font-size: 24px;
  font-weight: 400;
  color: #333333;
  flex: 1;
  text-align: center;
}

.textWay {
  padding-top: 22px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
